export const openExternal: (url: string) => Promise<void> = async (url) => Promise.resolve(window.open(url)).then();
